<template>
  <div class="card mt-3">
    <header class="card-header">
      <p class="card-header-title has-background-info-light has-text-info-dark">
        Zadnje odigrane borbe
      </p>
    </header>
    <div class="card-content">
      <div class="table-container">
        <table
          class="table is-bordered is-striped
        is-narrow is-hoverable is-fullwidth is-size-7-mobile"
        >
          <thead>
            <tr>
              <th>Mod</th>
              <th>Tip</th>
              <th>Vrijeme</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="borba in borbe" :key="borba.date">
              <td
                v-if="borba.type.startsWith('riverRace') || borba.gameMode.includes('CW_Duel_1v1')"
                class="has-background-primary has-text-white"
              >
                {{ borba.gameMode }}
              </td>
              <td v-else>{{ borba.gameMode | truncate(25) }}</td>
              <td
                v-if="borba.type.startsWith('riverRace') || borba.gameMode.includes('CW_Duel_1v1')"
                class="has-background-primary has-text-white"
              >
                {{ borba.type }}
              </td>
              <td v-else>{{ borba.type }}</td>
              <td
                v-if="borba.type.startsWith('riverRace') || borba.gameMode.includes('CW_Duel_1v1')"
                class="has-background-primary has-text-white"
              >
                {{ borba.date | moment('calendar') }}
              </td>
              <td v-else>{{ borba.date | moment('calendar') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { useRouter } from '@u3u/vue-hooks';

export default {
  setup() {
    const { route } = useRouter();
    const apiHost = process.env.VUE_APP_API_HOST;
    const borbeURL = '/player/last15/';
    const { id } = route.value.params;

    const borbe = ref([]);

    const API_URL = apiHost;

    async function getBorbe() {
      const response = await fetch(API_URL + borbeURL + id);
      const json = await response.json();
      borbe.value = json;
    }

    getBorbe();

    return {
      borbe,
    };
  },
};
</script>

<style></style>
